/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiSelect to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/select/#css
 */ export const MuiSelect = {
    defaultProps: {
        variant: 'outlined',
        size: 'medium'
    }
};

//# sourceMappingURL=simpleselect-overrides.js.map